import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Collapse, Navbar, NavbarToggler, NavLink } from 'reactstrap';

// Static Assets
import LogoIcon from '../assets/images/logo-icon@2x.png';
import { Context, web3Modal } from '../contexts/ContextProvider';
import TokenImage from '../assets/images/icons/paper_price.png';

// Static UI imports
import Menu from './Menu';

const Header = () => {
  const navigate = useNavigate();
  const { walletAddress, showLoader, connectWalletHandler, tokenBalance } = useContext(Context);

  useEffect(() => {
    if (web3Modal.cachedProvider) {
      connectWalletHandler();
    }
    // const header = document.getElementById('appHeader');
    // if (header) {
    //   const sticky = header.offsetTop;
    //   window.addEventListener('scroll', () => {
    //     if (window.pageYOffset > sticky) {
    //       header.classList.add('is-sticky');
    //     } else {
    //       header.classList.remove('is-sticky');
    //     }
    //   });
    // }

    // eslint-disable-next-line
  }, []);

  const [collapsed, setCollapsed] = useState<boolean>(false);

  return (
    <header className="header-horizontal" id="appHeader">
      <Container className="">
        <div className="d-flex align-items-center justify-content-between">
          <NavLink onClick={() => navigate('/')}>
            <img src={LogoIcon} className="header-logo" alt="Acrocalypse" />
          </NavLink>

          <div className="header-menu header-menu-sm">
            <Menu className="header-menu-list" />
          </div>

          <Navbar color="faded" light className={`${collapsed ? `navigation-active` : ``}`}>
            <NavbarToggler className="" onClick={() => setCollapsed(!collapsed)} />
            <Collapse className="responsive-navigation" isOpen={collapsed}>
              <div
                className="close-menu"
                style={{ display: 'flex' }}
                data-uw-styling-context="true"
                onClick={() => setCollapsed(!collapsed)}
              >
                <span className="icon-close" data-uw-styling-context="true"></span>
              </div>
              <Menu setCollapsed={setCollapsed} collapsed={collapsed} />
            </Collapse>
            {collapsed && <div className="menu-overlay" onClick={() => setCollapsed(!collapsed)}></div>}
          </Navbar>

          {!walletAddress && (
            <button
              type="button"
              className={`btn-mint-a-croc cursor-pointer ${showLoader ? `is-loading` : ``}`}
              onClick={() => connectWalletHandler()}
            >
              CONNECT
            </button>
          )}

          {walletAddress && (
            <div className="btn-mint-a-croc cursor-pointer">
              <img src={TokenImage} alt="Paper Token" /> &nbsp;
              <span>{tokenBalance}</span>
            </div>
          )}
        </div>
      </Container>
    </header>
  );
};

export default Header;
